// Reject an uncertain combined location request rather than silently editing
// its place name or executing unrelated room speech. Quoted queries stay literal.
export function hasUnrelatedPlaceSearchTail(query) {
  const text = String(query || '').trim();
  if (/^["“][\s\S]*["”]$/.test(text)) return false;
  for (const boundary of text.matchAll(/[.!?]\s+(?=\S)/g)) {
    const before = text.slice(0, boundary.index);
    if (boundary[0][0] === '.' && /\b(?:st|mt|ft|dr|mr|ms|ave|rd|blvd|no|u|s)$/i.test(before)) continue;
    const tail = text.slice(boundary.index + boundary[0].length);
    // Explicit additional steps/purpose are retained in the original request.
    if (!/^(?:(?:then|and|after (?:it|the map) loads|once (?:it|the map) loads)[,\s]+)?(?:click|press|type|scroll|zoom|select|show|wait|make|keep|open|so i can|because i|i want|i need)\b/i.test(tail)) return true;
  }
  return false;
}
